import rem from 'polished/lib/helpers/rem';

const _rem = (size) => rem(size, '16px');

export default _rem;



// WEBPACK FOOTER //
// ./src/utils/rem.js